import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CererePriorityModule } from './cerere-priority/cerere-priority.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, CererePriorityModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NomenclatoareModule { }
